/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_TitleInputs */

const en_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify Your Student Status`)
};

const de_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätige deinen Studentenstatus`)
};

const fr_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifie ton statut d'étudiant`)
};

const es_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique su estado de estudiante`)
};

const it_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica il Tuo Status di Studente`)
};

const nl_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifieer je studentenstatus`)
};

const pl_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź swój status studenta`)
};

const fi_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista Opiskelijastatuksesi`)
};

const da_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft din studerende status`)
};

const sv_onboarding_verify_title = /** @type {(inputs: Onboarding_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiera din studentstatus`)
};

/**
* | output |
* | --- |
* | "Verify Your Student Status" |
*
* @param {Onboarding_Verify_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_title = /** @type {((inputs?: Onboarding_Verify_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_title(inputs)
	if (locale === "fr") return fr_onboarding_verify_title(inputs)
	if (locale === "es") return es_onboarding_verify_title(inputs)
	if (locale === "it") return it_onboarding_verify_title(inputs)
	if (locale === "nl") return nl_onboarding_verify_title(inputs)
	if (locale === "pl") return pl_onboarding_verify_title(inputs)
	if (locale === "fi") return fi_onboarding_verify_title(inputs)
	if (locale === "da") return da_onboarding_verify_title(inputs)
	if (locale === "sv") return sv_onboarding_verify_title(inputs)
	return en_onboarding_verify_title(inputs)
});